import { atom } from "jotai";
import ShareSpacePanelRecord from "models/view-models/share-space-panel-record";

const ShareSpacePanelAtom = atom<ShareSpacePanelRecord>(
    new ShareSpacePanelRecord()
);

export default ShareSpacePanelAtom;
